/*
 CruiseCards Module
 */

import DetailApiManager from '../detailApiManager'

const CruiseCards = (function(DetailApiManager) {
    // ================== VARIABLE STATIC================== //
    var _static_url;
    var _translation = {};

    // ================== CONSTRUCTOR ================== //
    function CruiseCards(cruise_id, duration, is_best_sale, sharing_type, container) {
        this.id = cruise_id;
        this.duration = duration;
        this.is_best_sale = is_best_sale;
        this.status = 'loading' // or ready
        this.visible = true;
        this.fromStatic = false;

        // Try to get an existing element (from static search) or create it.
        if ($('#cards-' + this.id).length != 0) {
            this.fromStatic = true;
        } else {
            container.append(_loadingHtmlString.apply(this));
        }
        this.element = $('#cards-' + this.id);

        // Get info from api
        DetailApiManager.getCruiseDetail(cruise_id, this, function(data) {
            this.data = data;
            this.status = 'ready';
            if (!this.fromStatic) {
                this.element.html(_generateHtmlString.apply(this));
                // window.initJsLike($('#cards-' + this.id).find('.js-like'));
            }
            // Update dynamic information (when reservation type changes)
            this.setPrice(sharing_type);
            this.setMaxPassengers(sharing_type);
        });
    };

    // ================== STATIC METHOD ================== //
    CruiseCards.setStaticUrls = function(urls) {
        _static_url = urls;
    };

    CruiseCards.seti18nParam = function(data) {
        for (var key in data)
            _translation[key] = data[key];
    };

    // ================== PUBLIC METHOD ================== //
    CruiseCards.prototype.show = function(sharing_type, container) {
        this.setPrice(sharing_type);
        this.setMaxPassengers(sharing_type);
        container.append(this.element);
        if (!this.visible) {
            this.visible = true;
            this.element.show();
        }
    };

    CruiseCards.prototype.setPrice = function(sharing_type) {
        if (this.status == 'ready')
            $('#cards-' + this.id + ' .cards-price').html(_getPrice.apply(this, [sharing_type]));
    };

    CruiseCards.prototype.setMaxPassengers = function(sharing_type) {
        if (this.status == 'ready')
            $('#cards-' + this.id + ' .max-passengers').html(_travelers.apply(this, [sharing_type]));
    };

    CruiseCards.prototype.hide = function() {
        if (this.visible) {
            this.visible = false;
            this.element.hide();
        }
    };

    // ================== PRIVATE METHOD ================== //
    function _generateHtmlString() {
        let best_sale_cls = this.is_best_sale ? 'best-sale' : '';
        var r = '' +
            '    <a href="' + this.data.card_url + '"' +
            '       target="_blank"' +
            '       title="' + this.data.card_title + '"' +
            '       class="base-cards cruise-cards ' + best_sale_cls + '">' +
            '        <div class="cards-img">' +
            '            <div class="cards-img__photo" style="background-image:linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.8)),url(\'' + this.data.card_photo_url + '\')"></div>' +
            '            <div class="cards-img__overlay">' +
            '                <!-- Skipper round icon -->'
            if(this.data.card_skipper_name && this.data.card_skipper_photo_url) {
                r += '' +
                '                <div class="skipper-round">' +
                '                    <div class="skipper-round__icon fa fa-anchor"></div>' +
                '                    <img class="skipper-round__img" src="' + this.data.card_skipper_photo_url + '" alt="">' +
                '                    <div class="skipper-round__info">' +
                '                        <div class="first-name">' + this.data.card_skipper_name + '</div>' +
                '                        <div class="port">' + this.data.card_starting_port.parent + '</div>' +
                '                    </div>' +
                '                </div>'
            }
            r += '' + 
            '                <!-- Cruise title -->' +
            '                <div class="title">' + this.data.card_title + '</div>' +
            '                <!-- Cruise rating -->' +
            '               ' + _getRating(this.data.card_rating, this.data.card_review_count) +
            '            </div>' +
            '            <div class="cards-best-sale">' + _translation['best-sale'] + '</div>' +
            '               ' + _getAllIncluded(this.data.card_is_all_included) +
            '            <div class="cards-like js-like" data-target="' + this.data.card_slug + '" data-url="/fr/croisiere/like/" data-add-msg=".product-head__like__msg-like">' +
            '                <i class="fa fa-heart-o"></i>' +
            '            </div>' +
            '        </div>' +
            '        <div class="cards-description">' +
            '            <div class="starting-port"><span class="icon fa fa-map-marker" aria-hidden="true"></span>' + this.data.card_starting_port.name + '</div>' +
            '            <div class="additional-info">' +
            '                <div>' + this.data.card_boat_info + '</div>' +
            '                <div class="max-passengers">' + _travelers.apply(this) + '</div>' +
            '                <div>' + this.data.card_right_info + '</div>' +
            '            </div>' +
            '        </div>' +
            '        <div class="cards-price">' +
            '            <div class="price"></div>' +
            '        </div>' +
            '    </a>';
        return r;
    }

    function _loadingHtmlString() {
        var r = '' +
            '<div class="cards-wrapper" id="cards-' + this.id + '">' +
            '    <a href=""' +
            '       target="_blank"' +
            '       title=""' +
            '       class="base-cards cruise-cards loading">' +
            '        <div class="cards-img" style="background-image:linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.8))">' +
            '            <div class="cards-img__overlay">' +
            '                <!-- Skipper round icon -->' +
            '                <div class="skipper-round">' +
            '                    <div class="skipper-round__icon fa fa-anchor"></div>' +
            '                    <img class="skipper-round__img" src="" alt="">' +
            '                    <div class="skipper-round__info">' +
            '                        <div class="first-name"></div>' +
            '                        <div class="port"></div>' +
            '                    </div>' +
            '                </div>' +
            '                <!-- Cruise title -->' +
            '                <div class="title">Toto</div>' +
            '                <!-- Cruise rating -->' +
            '               ' + _getRating(-1, 1) +
            '            </div>' +
            '            <div class="cards-best-sale">' + _translation['best-sale'] + '</div>' +
            '            <div class="cards-like js-like" data-target="" data-url="/fr/croisiere/like/" data-add-msg=".product-head__like__msg-like">' +
            '                <i class="fa fa-heart-o"></i>' +
            '            </div>' +
            '        </div>' +
            '        <div class="cards-description">' +
            '            <div class="starting-port"><span class="fa fa-map-marker" aria-hidden="true"></span>loading</div>' +
            '            <div class="additional-info">' +
            '                <div>loading</div>' +
            '                <div>loading</div>' +
            '                <div>loading</div>' +
            '            </div>' +
            '        </div>' +
            '        <div class="cards-price">' +
            '            <div class="price"></div>' +
            '        </div>' +
            '    </a>' +
            '</div>';
        return r;
    }

    function _getPrice(sharing_type) {

        if (sharing_type == 'private') {
            var p_data = this.data.card_min_private_price
        } else {
            var p_data = this.data.card_min_shared_price
        }

        var p = Math.ceil(parseFloat(p_data.min))

        if (sharing_type == 'private') {
            var p_day_data = this.data.card_min_private_price_by_day
        } else {
            var p_day_data = this.data.card_min_shared_price_by_day
        }

        var p_day = Math.ceil(parseFloat(p_day_data))

        var html = ''

        if (sharing_type == 'private') {
            html += '<div class="per">'+ _translation['per_group_card_label'] +'</div>'
        } else {
            html += '<div class="per">'+ _translation['per_person_card_label'] +'</div>'
        }

        if (p_data.promo) {
            html += '<div class="promo">- '+ p_data.promo +'%</div>'
            var p_wo_promo = '<span class="crossed">'+p_data.min_wo_promo+'€</span>&nbsp;'
        } else {
            var p_wo_promo = ''
        }

        var price_html = ''
        var tpl;
        if (sharing_type == 'private') {
            if (this.data.card_is_min_private_price_exact) {
              tpl = _translation['price-boat-exact']
            } else {
              tpl = _translation['price-boat']
            }
        } else {
            if (this.data.card_is_min_shared_price_exact) {
              tpl = _translation['price-pers-exact']
            } else {
              tpl = _translation['price-pers']
            }
        }

        if(this.data.is_by_day) {
            var unit = _translation['day']
        } else {
            var unit = _translation['hour']            
        }
        price_html = tpl.replace(/{unit}/, unit).replace(/{day_price}/, p_day).replace(/{price}/, p).replace(/{price_wo_promo}/, p_wo_promo)

        html += '<div class="price">'+ price_html +'</div>'

        return html
    }

    function _getRating(rating, count) {
        // There is no rating add visibilty hidden to the rating div.
        if (rating <= 0)
            var ratingHtml = '<div class="rating" style="visibility:hidden;">';
        else
            var ratingHtml = '<div class="rating">';
        // Add the star
        for (var i = 0; i < 5; i++) {
            ratingHtml += '<span class="fa fa-star' + (rating > i ? '' : '-o') + '"></span>'
        }
        // Add the rating
        ratingHtml += '<span> ( ' + rating + '/5 )</span>';
        // Add the total reviews.
        if (count == 1)
            ratingHtml += '<span> - ' + _translation['review-count-single'].replace(1, count) + '</span>';
        else
            ratingHtml += '<span> - ' + _translation['review-count-plural'].replace(2, count) + '</span>';
        // Close the ratingHtml
        ratingHtml += '</div>';

        return ratingHtml;
    };

    function _travelers(sharing_type) {
        if (sharing_type == 'private') {
            return this.data.card_max_passenger_private_number + ' ' + _translation['pers-max'];
        } else {
            return this.data.card_max_passenger_shared_number + ' ' + _translation['pers-max'];            
        }
    }

    function _getAllIncluded(is_all_included) {
        let allinc = ''
        if(is_all_included) {
            allinc = '<div class="badge badge-warning cards-all-included">' + _translation['all-included'] + '</div>'
        }
        return allinc
    }

    return CruiseCards;
})(DetailApiManager);

export default CruiseCards


// WEBPACK FOOTER //
// ./search/static/search/js/objects/cruiseCards.js